import * as Sentry from "@sentry/react";

type SerializableRecord = Record<string, unknown>;

let sentryInitialized = false;

export function initializeSentry(): void {
	try {
		// Only initialize in production builds
		if (!import.meta.env.PROD) {
			return;
		}
		const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
		if (!dsn) {
			return;
		}

		if (sentryInitialized) return;

		Sentry.init({
			dsn,
			environment: import.meta.env.MODE,
			// Keep default sample rates conservative; can be adjusted per need
			tracesSampleRate: 0.1,
			// Replay is optional; keep disabled by default to avoid noise
			replaysSessionSampleRate: 0.0,
			replaysOnErrorSampleRate: 0.0,
		});

		sentryInitialized = true;
	} catch {
		// Silent fail: app must never break due to monitoring
	}
}

export function reportErrorToSentry(error: unknown, context?: SerializableRecord): string | undefined {
	try {
		if (!sentryInitialized) return undefined;
		return Sentry.captureException(error, scope => {
			if (context) {
				scope.setExtras(context);
			}
			return scope;
		});
	} catch {
		return undefined;
	}
}

export function captureMessage(message: string, context?: SerializableRecord, level: Sentry.SeverityLevel = "info"): string | undefined {
	try {
		if (!sentryInitialized) return undefined;
		return Sentry.captureMessage(message, scope => {
			scope.setLevel(level);
			if (context) scope.setExtras(context);
			return scope;
		});
	} catch {
		return undefined;
	}
}


